'use strict';

import $ from 'jquery';
import Cookies from './cookies';

class S3Upload {

  constructor (file) {
    const csrf_token = Cookies.get('csrf_token');
    // const csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let self, fileJQXHR, formData;
    self = this;

    return new Promise(function(resolve, reject) {

      fileJQXHR = $.ajax({
        type: "POST",
        url: "/api/presigned_post",
        dataType: "json", // The server returns a JSON document

        data: {
          content_type: file.type, // Send the server the file mimetype for AWS signing
        },

        beforeSend: function(xhr) {
          xhr.setRequestHeader("X-CSRF-Token", csrf_token);
        },

        error: function(xhr, status, error) {
          console.log("Could not get presigned S3 post", xhr, status, error, xhr["responseText"]);
          reject("Could not get presigned S3 post");
        },

        statusCode: {
          201: function(data, status, xhr) {
            self.presignedPost = data;
            // console.log("Got presigned post from S3", self.presignedPost);

            formData = new FormData();

            // Do not change the order of these fields
            // For some reason S3 wants `file` to be last and `key` to be early in the request
            formData.append("key", self.presignedPost["key"]);
            formData.append("acl", self.presignedPost["acl"]);
            formData.append("policy", self.presignedPost["policy"]);
            formData.append("x-amz-credential", self.presignedPost["x-amz-credential"]);
            formData.append("x-amz-signature", self.presignedPost["x-amz-signature"]);
            formData.append("x-amz-algorithm", self.presignedPost["x-amz-algorithm"]);
            formData.append("x-amz-date", self.presignedPost["x-amz-date"]);
            formData.append("success_action_status", self.presignedPost["success_action_status"]);
            formData.append("Content-Type", file.type);
            formData.append("file", file, file.name);

            fileJQXHR = $.ajax({
              type: "POST",
              url: "https://" + self.presignedPost["bucket_name"] + ".s3.amazonaws.com",
              processData: false, // Do not perform smart processing on the outgoing data
              contentType: false, // Do not permit jQuery to determine the content type of the outgoing data
              mimeType: "multipart/form-data", // S3 requires this form encoding format
              dataType: "xml", // S3 will send back an XML document
              data: formData, // Submit our constructed form above

              // // We need to build a custom XHR object with a progress event bound.
              // // jQuery doesn't support this progress event natively
              // xhr: function() {
              //   var xhr = new window.XMLHttpRequest();
              //   xhr.upload.addEventListener("progress", function(event) {
              //     if (event.lengthComputable) {
              //       self.resizeProgressBar((event.loaded / event.total) * 100);
              //     }
              //   }, false);
              //   return xhr;
              // },

              error: function(xhr, status, error) {
                // The user aborted the request intentionally, so no error is shown visually
                if (status === "abort") {
                  console.log("User aborted S3 upload");
                  reject("User aborted S3 upload");
                }
                // Something else bad happened
                else {
                  console.log("Could not upload to Amazon S3", xhr, status, error, xhr["responseText"]);
                  reject("Could not upload to Amazon S3");
                }
              },

              statusCode: {
                201: function(xmlDocument, status, xhr) {
                  self.url = $(xmlDocument).find('Location').first().text();
                  // console.log("Successful upload to Amazon S3", self.url);
                  resolve(self.url);
                }
              }
            });
          }
        }
      });
    });
  }
}

export default S3Upload;



// WEBPACK FOOTER //
// ./app/javascript/modules/s3-upload.js